import { IMobilyticsScenario } from "../IMobilyticsScenario";

export interface ISubmitMobilyticsJobRequest {
  scenarios: IMobilyticsScenario[];
}
